// extracted by mini-css-extract-plugin
module.exports = {"button":"SubmitButton-module--button--2-o0W"};